import React from 'react';
import { Container, Row, Col, Tab, Nav } from 'react-bootstrap';
import projImg1 from '../assets/img/maple-financial.png';
// import projImg2 from '../assets/img/project-img2.png';
// import projImg3 from '../assets/img/project-img3.png';
// import colorSharp from '../assets/img/color-sharp.png';
import projVid1 from '../assets/video/budget-app.mp4';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {
  return (
    <section className='project' id='project'>
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? 'animate__animated animate__fadeIn' : ''
                  }
                >
                  <h2>Projects</h2>
                  <Tab.Container id='projects-tabs' defaultActiveKey='first'>
                    <Nav
                      variant='pills'
                      className='nav-pills mb-5 justify-content-center align-items-center'
                      id='pills-tab'
                    >
                      <Nav.Item>
                        <Nav.Link eventKey='first'>Fluffy Fury</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey='second'>Maple Financial</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey='third'>Budgeting App</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content
                      id='slideInUp'
                      className={
                        isVisible ? 'animate__animated animate__slideInUp' : ''
                      }
                    >
                      <Tab.Pane eventKey='first'>
                        <Row>
                          <center>
                            <p>
                              Fluffy Fury is a 3D stealth-action game developed
                              in Unity where players control a squirrel
                              collecting food while avoiding and outsmarting
                              enemies such as dogs, humans, and monkeys. The
                              game features physics-based movement, projectile
                              mechanics, enemy AI, character animations,
                              interactive environments, and multiple levels.
                            </p>
                            <div className='ratio ratio-16x9'>
                              <iframe
                                width='560'
                                height='315'
                                src='https://www.youtube.com/embed/-RggX4hhoR0?si=T5ONydeKfmQgoU0F'
                                title='Fluffy Fury Game Trailer'
                                frameborder='0'
                                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                                referrerpolicy='strict-origin-when-cross-origin'
                                allowfullscreen
                              ></iframe>
                            </div>
                          </center>
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey='second'>
                        <Row>
                          <center>
                            <p>
                              Website created for a financial and wealth
                              management company using JavaScript, React,
                              Bootstrap and deployed with Netlify.
                            </p>
                            <a
                              class='btn btn-primary'
                              href='http://www.maplefinancial.org'
                              role='button'
                              target='_blank'
                              rel='noreferrer'
                            >
                              Demo
                            </a>
                          </center>
                        </Row>
                        <br></br>
                        <img src={projImg1} alt='Maple Financial'></img>
                      </Tab.Pane>
                      <Tab.Pane eventKey='third'>
                        <Row>
                          <center>
                            <p>
                              UI/UX design for a budgeting app made in Adobe XD.
                            </p>
                            <video width='620' controls>
                              <source src={projVid1} type='video/mp4' />
                              Your browser does not support the video tag.{' '}
                            </video>
                          </center>
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      {/* <img className='background-image-right' src={colorSharp}></img> */}
    </section>
  );
};
